<template>
  <div v-if="content" class="attraction-list">
    <div class="max-w-2xl mx-auto mb-6">
      <div class="text-center px-7 py-5 font-luckiest rounded-xl text-grey-600 bg-white">
        {{content.title_age_filter}}
      </div>
      <div class="grid gap-2 md:gap-6 mt-2 md:mt-6" :class="'grid-cols-'+(rangeAgeFilter.length+1)">
        <button :class="{'bg-primary text-white': minimumAge === 3, 'text-grey-600 bg-white': minimumAge !== 3}" @click="toggleAgeFilter(3)" class="text-center px-7 py-5 font-luckiest rounded-xl hover:scale-110 transform duration-300 ease-out">
          dès 3 ans / 1m 
        </button>
        <button :class="{'bg-primary text-white': minimumAge === 6, 'text-grey-600 bg-white': minimumAge !== 6}" @click="toggleAgeFilter(6)" class="text-center px-7 py-5 font-luckiest rounded-xl hover:scale-110 transform duration-300 ease-out">
          dès 6 ans / 1m15
        </button>
        <button :class="{'bg-primary text-white': minimumAge === 9, 'text-grey-600 bg-white': minimumAge !== 9}" @click="toggleAgeFilter(9)" class="text-center px-7 py-5 font-luckiest rounded-xl hover:scale-110 transform duration-300 ease-out">
          dès 9 ans / 1m30
        </button>
        <button :class="{'bg-primary text-white': minimumAge === null, 'text-grey-600 bg-white': minimumAge !== null}" @click="minimumAge = null" class="text-center px-7 py-5 font-luckiest rounded-xl hover:scale-110 transform duration-300 ease-out">
          Tous les parcours
        </button>
      </div>
    </div>
    <transition-group tag="ul" class="list" name="list">
      <li v-for="blok in filteredAttractions" :key="blok._uid">
        <component class="card" :content="blok" :is="blok.component"></component>
      </li>
    </transition-group>
  </div>
</template>

<script>
export default {
  props: {
    content: null
  },
  data() {
    return {
      minimumAge: null
    }
  },
  methods: {
    toggleAgeFilter: function(age) {
      if(this.minimumAge !== age) {
        this.minimumAge = age
      } else {
        this.minimumAge = null
      }
    }
  },
  computed: {
    rangeAgeFilter() {
      return this.content.age_range_array.split(',').map(Number);
    },
    filteredAttractions() {
      if(this.minimumAge) {
        return this.content.attractions.filter(element => {
          if(element.age_minimum) {
            return parseInt(element.age_minimum) === this.minimumAge
          } else {
            return true // Ajoute l'attraction même si c'est un age minimum n'est pas ajouté
          }
        });
      } else {
        return this.content.attractions
      }
    }
  }
};
</script>

<style lang="scss">
.attraction-list {
  width: 1024px;
  max-width: $max-width;

  margin: 30px auto;
  .list {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 20px;
    margin: auto;
    width: 100%;
    li {
      // height: 375px;
    }
    .card {
      // display: flex;
      // align-items: center;
      // justify-content: center;
      // position: relative;
      // overflow: hidden;
      // grid-row: span 2;
      // height: 100%;
    }
  }
}

.list-enter-active,
.list-leave-active {
  transition: transform 0.3s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(40px) scale(0.5);
  transition: transform 0s;
}
</style>
